export default __webpack_public_path__ + "static/media/16_Have-a-dance.09f06391.jpg";